<template xmlns:v-touch="">
	<div id="app" v-resize:debounce="onResize">
		<header-bar></header-bar>
		<transition :name="pageTransition()" mode="out-in">
			<router-view
				role="main"
				class="main"
				v-touch:swipe.left="next"
				v-touch:swipe.right="prev"
			></router-view>
		</transition>
	</div>
</template>

<script>
	import resize from 'vue-resize-directive';
	import {mapGetters,mapActions} from "vuex";
	import HeaderBar from "./components/HeaderBar";
	export default {
		components: {HeaderBar},
		directives: {
			resize,
		},
		methods: {
			...mapGetters(['pageTransition', 'previousPage', 'nextPage', 'hasPreviousPage', 'hasNextPage']),
			...mapActions(['setWindowSize']),
			prev() {
				if (this.hasPreviousPage())
					this.$router.push(this.previousPage());
			},
			next() {
				if (this.hasNextPage())
					this.$router.push(this.nextPage());
			},
			onResize() {
				this.setWindowSize({ width: window.innerWidth, height: window.innerHeight});
			},
		}
	}
</script>

<style lang="scss">
	#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		color: $text-color;
		height: 100vh;
	}
	.main {
		margin: 0 15px;
	}
	body {
		margin: 0;
		padding: 0;
	}
	.shortcut-actions {
		display: none;
	}
	.fade-enter-active,
	.fade-leave-active {
		transition: opacity 0.25s;
	}
	.fade-enter,
	.fade-leave-to {
		opacity: 0;
	}
	.slide-left-enter-active, .slide-left-leave-active, .slide-right-enter-active, .slide-right-leave-active {
		transition: all .25s;
	}
	.slide-left-enter, .slide-left-leave-active, .slide-right-enter, .slide-right-leave-active {
		opacity: 0;
	}
	.slide-left-enter, .slide-right-leave-active {
		transform: translateX(100vh);
	}
	.slide-left-leave-active, .slide-right-enter {
		transform: translateX(-100vh);
	}
</style>
